var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{attrs:{"id":"main-container"}},[(_vm.isLoggedIn !='loginNow' )?_c('div',[_c('HeaderBar')],1):_vm._e(),_c('div',{attrs:{"id":"main-router-view"}},[_c('router-view')],1),(_vm.isLoggedIn !='loginNow' )?_c('div',[_c('FooterBar')],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }